module.exports = "/packs/images/svg/ireland/facilities/ski~6c6481664992eed5ea59b3c52a99ef99.svg";